import React from 'react';
import { RediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Row } from 'shared/components/birch/row';
import CandidateChips from 'talent_matching/components/shared/candidate_chips';
import { RejectModalProvider } from 'application_review/components/reject_modal_context';
import SocialLinks from 'talent_matching/components/shared/social_links';
import { Person } from 'talent_matching/types';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import noop from 'lodash/noop';

type Props = {
  application: RediscoveryApplication;
};

const RediscoveryCandidateCell = ({ application }: Props) => {
  return (
    <Stack
      spacing={1}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <Row spacing={0.5}>
        <SecondaryBody medium className="candidate-full-name pii-blur">
          {application.fullName}
        </SecondaryBody>
      </Row>
      <CandidateChips application={application as unknown as Person} />
      <RejectModalProvider>
        <SocialLinks
          application={application as unknown as Person}
          onRejectSuccess={noop}
        />
      </RejectModalProvider>
    </Stack>
  );
};

export default RediscoveryCandidateCell;
